import { useEffect } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { resolveImageUrl } from "../lib/api";

export default function Lightbox({ images, index, onClose, onPrev, onNext }) {
    useEffect(() => {
        const handler = (e) => {
            if (e.key === "Escape") onClose();
            else if (e.key === "ArrowLeft") onPrev();
            else if (e.key === "ArrowRight") onNext();
        };
        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    }, [onClose, onPrev, onNext]);

    if (index == null) return null;
    const img = images[index];

    return (
        <AnimatePresence>
            <motion.div
                key="lb"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.4 }}
                className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center"
                data-testid="lightbox-overlay"
            >
                <button onClick={onClose} className="absolute top-6 right-6 p-3 text-white hover:text-gold" data-testid="lightbox-close">
                    <X size={24} />
                </button>
                <button onClick={onPrev} className="absolute left-6 top-1/2 -translate-y-1/2 p-3 text-white hover:text-gold" data-testid="lightbox-prev">
                    <ChevronLeft size={32} />
                </button>
                <button onClick={onNext} className="absolute right-6 top-1/2 -translate-y-1/2 p-3 text-white hover:text-gold" data-testid="lightbox-next">
                    <ChevronRight size={32} />
                </button>

                <div className="w-[92vw] h-[88vh]">
                    <TransformWrapper minScale={1} maxScale={4} doubleClick={{ mode: "toggle" }}>
                        <TransformComponent wrapperClass="!w-full !h-full" contentClass="!w-full !h-full flex items-center justify-center">
                            <img
                                src={resolveImageUrl(img?.url || img)}
                                alt=""
                                className="max-w-full max-h-full object-contain"
                                draggable={false}
                            />
                        </TransformComponent>
                    </TransformWrapper>
                </div>

                <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/60 text-xs tracking-[0.3em] uppercase">
                    {index + 1} / {images.length} · Use ← → keys · Double-click to zoom
                </div>
            </motion.div>
        </AnimatePresence>
    );
}
